<template>
    <div class="animated fadeIn">
        <b-row>
            <b-col lg="12">
                <b-card>
                    <div slot="header">
                        <strong>Báo cáo đối chiếu dữ liệu</strong>
                    </div>
                    <b-form id="reportForm">
                        <!--<b-row>
                            <b-col offset-md="1">
                                <b-form-group label=""
                                              :label-cols="3" label-cols-md="3"
                                              :horizontal="true"
                                              label-align="left">
                                    <b-form-radio-group v-model="searchForm.part">
                                        <b-form-radio value="1">Phần 01 - Tổng hợp chung</b-form-radio>
                                        <b-form-radio value="2">Phần 02 - Chi tiết từng đơn vị trực thuộc</b-form-radio>
                                    </b-form-radio-group>
                                </b-form-group>
                            </b-col>
                        </b-row>-->
                        <b-row>
                            <b-col offset-md="1">
                                <b-form-group label="Nguồn dữ liệu:"
                                              :label-cols="3" label-cols-md="3"
                                              :horizontal="true"
                                              label-align="left">
                                    <div class="col-6 no-padding">
                                        <select2 v-model="searchForm.dataSource" :options="dataSources" multiple placeholder="--- Tất cả ---"></select2>
                                    </div>
                                </b-form-group>
                            </b-col>
                        </b-row>
                        <b-row>
                            <b-col offset-md="1">
                                <b-form-group label="Loại tài sản:"
                                              :label-cols="3" label-cols-md="3"
                                              :horizontal="true"
                                              label-align="left">
                                    <div class="col-6 no-padding">
                                        <select2 v-model="searchForm.syncSourceType" :options="dataTypes" multiple placeholder="--- Tất cả ---"></select2>
                                    </div>
                                </b-form-group>
                            </b-col>
                        </b-row>
                        <b-row>
                            <b-col offset-md="1">
                                <b-form-group label="Biểu mẫu:"
                                              :label-cols="3" label-cols-md="3"
                                              :horizontal="true"
                                              label-align="left">
                                    <div class="col-6 no-padding">
                                        <select2 v-model="searchForm.dataPart" :options="reportParts" multiple placeholder="--- Tất cả ---"></select2>
                                    </div>
                                </b-form-group>
                            </b-col>
                        </b-row>
                        <b-row>
                            <b-col offset-md="1">
                                <b-form-group label="Đơn vị xuất báo cáo:"
                                              label-for="input-unit"
                                              :label-cols="3" label-cols-md="3"
                                              :horizontal="true"
                                              label-align="left">
                                    <b-form-input type="text"
                                                  style="display:none;"
                                                  class="col-md-6"
                                                  v-model="$v.searchForm.unitId.$model"
                                                  :state="$v.searchForm.unitId.$dirty? !$v.searchForm.unitId.$error : null">
                                    </b-form-input>
                                    <div class="no-padding col-6">
                                        <top-level-unit :cached="true" v-model="searchForm.unitId" :allowClear="isAdmin" :placeholder="isAdmin ? '--- Tất cả ---' : '--- Chọn đơn vị ---'"></top-level-unit>
                                    </div>
                                    <b-form-invalid-feedback>
                                        Vui lòng chọn đơn vị xuất báo cáo
                                    </b-form-invalid-feedback>
                                </b-form-group>
                            </b-col>
                        </b-row>
                        <!--<b-row>
                            <b-col offset-md="1">
                                <b-form-group label="Cấp hành chính:"
                                              label-for="input-unit"
                                              :label-cols="3" label-cols-md="3"
                                              :horizontal="true"
                                              label-align="left">
                                    <b-form-radio-group v-model="searchForm.administrativeLevel" name="administrative-level-radio">
                                        <b-form-radio value="" checked>Tất cả</b-form-radio>
                                        <b-form-radio value="1">Trung ương</b-form-radio>
                                        <b-form-radio value="2">Địa phương</b-form-radio>
                                    </b-form-radio-group>
                                </b-form-group>
                            </b-col>
                        </b-row>
                        <b-row>
                            <b-col offset-md="1">
                                <b-form-group label="Ban quản lý dự án:"
                                              label-for="input-unit"
                                              :label-cols="3" label-cols-md="3"
                                              :horizontal="true"
                                              label-align="left">
                                    <b-form-radio-group v-model="searchForm.unitTypeSelected" name="unit-type-radio">
                                        <b-form-radio value="" checked>Tất cả</b-form-radio>
                                        <b-form-radio value="1">Chỉ đơn vị quản lý dự án</b-form-radio>
                                        <b-form-radio value="2">Không đơn vị quản lý dự án</b-form-radio>
                                    </b-form-radio-group>
                                </b-form-group>
                            </b-col>
                        </b-row>
                        <b-row v-if="searchForm.administrativeLevel == 2">
                            <b-col offset-md="1">
                                <b-form-group label="Cấp đơn vị:"
                                              label-for="input-unit"
                                              :label-cols="3" label-cols-md="3"
                                              :horizontal="true"
                                              label-align="left">
                                    <div class="col-6 no-padding">
                                        <select2 v-model="searchForm.unitLevelId" :options="unitLevels" placeholder="--- Tất cả ---" multiple allowClear></select2>
                                    </div>
                                </b-form-group>
                            </b-col>
                        </b-row>-->
                        <!--<b-row>
                            <b-col offset-md="1">
                                <b-form-group label="Bậc đơn vị:"
                                              label-for="input-startdate"
                                              :label-cols="3" label-cols-md="3"
                                              :horizontal="true"
                                              label-align="left">
                                    <div class="col-6 p-l-r-0">
                                        <input type="hidden" v-model="searchForm.unitLevel" name="unitLevel" />
                                        <select2 v-if="listReportUnitLevel.length > 0" :options="listReportUnitLevel"
                                                 v-model="searchForm.unitLevel"></select2>
                                        <b-form-invalid-feedback>
                                            Vui lòng chọn bậc đơn vị
                                        </b-form-invalid-feedback>
                                    </div>
                                </b-form-group>
                            </b-col>
                        </b-row>-->
                        <!--<template v-if="searchForm.syncSourceType.length == 1">-->
                        <!--<b-row>
                            <b-col offset-md="1">
                                <b-form-group label="Nhóm tài sản lớn:"
                                              label-for="input-quantity"
                                              :label-cols="3" label-cols-md="3"
                                              :horizontal="true"
                                              label-align="left">
                                    <div class="col-6 no-padding">
                                        <treeselect v-model="searchForm.assetTypeGroupId" ref="assetTypeGroupTree"
                                                    :max-height="390"
                                                    multiple
                                                    allowClear
                                                    placeholder="--- Tất cả ---"
                                                    :options="assetTypeGroups" />
                                    </div>
                                </b-form-group>
                            </b-col>
                        </b-row>
                        <b-row>
                            <b-col offset-md="1">
                                <b-form-group label="Loại tài sản:"
                                              label-for="input-quantity"
                                              :label-cols="3" label-cols-md="3"
                                              :horizontal="true"
                                              label-align="left">
                                    <div class="col-6 no-padding">
                                        <treeselect v-model="searchForm.assetTypeId"
                                                    :max-height="390"
                                                    multiple
                                                    allowClear
                                                    placeholder="--- Tất cả ---"
                                                    :options="assetTypes" />
                                    </div>
                                </b-form-group>
                            </b-col>
                        </b-row>
                        <b-row>
                            <b-col offset-md="1">
                                <b-form-group label="Bậc loại tài sản:"
                                              label-for="input-startdate"
                                              :label-cols="3" label-cols-md="3"
                                              :horizontal="true"
                                              label-align="left">
                                    <div class="col-6 p-l-r-0">
                                        <input type="hidden" v-model="searchForm.assetTypeLevel" name="assetTypeLevel" />
                                        <select2 v-if="listReportAssetTypeLevel.length > 0" :options="listReportAssetTypeLevel"
                                                 v-model="searchForm.assetTypeLevel"></select2>
                                        <b-form-invalid-feedback>
                                            Vui lòng chọn bậc tài sản
                                        </b-form-invalid-feedback>
                                    </div>
                                </b-form-group>
                            </b-col>
                        </b-row>-->
                        <!--<b-row>
                            <b-col offset-md="1">
                                <b-form-group label="Hiển thị chi tiết tài sản:"
                                              label-for="input-startdate"
                                              :label-cols="3" label-cols-md="3"
                                              :horizontal="true"
                                              label-align="left">
                                    <div class="col-6 p-l-r-0">
                                        <b-form-checkbox v-model="searchForm.showAssetDetail"></b-form-checkbox>
                                    </div>
                                </b-form-group>
                            </b-col>
                        </b-row>-->
                        <!--</template>-->
                        <b-row>
                            <b-col offset-md="1">
                                <b-form-group label="Năm báo cáo:"
                                              label-for="input-startdate"
                                              :label-cols="3" label-cols-md="3"
                                              :horizontal="true"
                                              label-align="left">
                                    <!--<div class="col-6 no-padding">
                                        <select2 v-model="searchForm.years" :options="reportYears" placeholder="--- Tất cả ---" multiple></select2>
                                    </div>-->
                                    <label class="col-form-label">2020</label>
                                </b-form-group>
                            </b-col>
                        </b-row>
                        <!--<template v-if="periodType == 1">
                            <b-row>
                                <b-col offset-md="1">
                                    <b-form-group label="Ngày báo cáo:"
                                                  label-for="input-startdate"
                                                  :label-cols="3" label-cols-md="3"
                                                  :horizontal="true"
                                                  label-align="left"
                                                  label-class="required">
                                        <input type="hidden" v-model="searchForm.reportDate" name="reportDate" />
                                        <b-form-input type="text" style="display: none"
                                                      aria-describedby="reportDateFeedback"
                                                      v-model="$v.searchForm.reportDate.$model"
                                                      :state="$v.searchForm.reportDate.$dirty ? !$v.searchForm.reportDate.$error : null">
                                        </b-form-input>
                                        <date-picker id="input-startdate"
                                                     v-model="searchForm.reportDate"
                                                     class="col-6 no-padding"
                                                     placeholder="dd/mm/yyyy">
                                        </date-picker>
                                        <b-form-invalid-feedback>
                                            Vui lòng chọn ngày báo cáo
                                        </b-form-invalid-feedback>
                                    </b-form-group>
                                </b-col>
                            </b-row>
                        </template>
                        <template v-else>
                            <b-row>
                                <b-col offset-md="1">
                                    <b-form-group label="Từ ngày:"
                                                  label-for="input-startdate"
                                                  :label-cols="3" label-cols-md="3"
                                                  :horizontal="true"
                                                  label-align="left"
                                                  label-class="required">
                                        <input type="hidden" v-model="searchForm.reportStartDate" name="reportStartDate" />
                                        <b-form-input type="text" style="display: none"
                                                      aria-describedby="reportStartDateFeedback"
                                                      v-model="$v.searchForm.reportStartDate.$model"
                                                      :state="$v.searchForm.reportStartDate.$dirty ? !$v.searchForm.reportStartDate.$error : null">
                                        </b-form-input>
                                        <date-picker id="input-startdate"
                                                     v-model="searchForm.reportStartDate"
                                                     class="col-6 no-padding"
                                                     placeholder="dd/mm/yyyy">
                                        </date-picker>
                                        <b-form-invalid-feedback>
                                            Vui lòng chọn từ ngày
                                        </b-form-invalid-feedback>
                                    </b-form-group>
                                </b-col>
                            </b-row>
                            <b-row>
                                <b-col offset-md="1">
                                    <b-form-group label="Đến ngày:"
                                                  label-for="input-startdate"
                                                  :label-cols="3" label-cols-md="3"
                                                  :horizontal="true"
                                                  label-align="left"
                                                  label-class="required">
                                        <input type="hidden" v-model="searchForm.reportEndDate" name="reportEndDate" />
                                        <b-form-input type="text" style="display: none"
                                                      aria-describedby="reportEndDateFeedback"
                                                      v-model="$v.searchForm.reportEndDate.$model"
                                                      :state="$v.searchForm.reportEndDate.$dirty ? !$v.searchForm.reportEndDate.$error : null">
                                        </b-form-input>
                                        <date-picker id="input-startdate"
                                                     v-model="searchForm.reportEndDate"
                                                     class="col-6 no-padding"
                                                     placeholder="dd/mm/yyyy">
                                        </date-picker>
                                        <b-form-invalid-feedback>
                                            Vui lòng chọn đến ngày
                                        </b-form-invalid-feedback>
                                    </b-form-group>
                                </b-col>
                            </b-row>
                        </template>-->
                        <b-row>
                            <b-col offset-md="1">
                                <b-form-group label="Đơn vị tính giá trị:"
                                              :label-cols="3" label-cols-md="3"
                                              :horizontal="true"
                                              label-align="left">
                                    <!--<div class="col-6 p-l-r-0">
                                        <select2 :options="listUnitCurrencys" name="unitCurrency"
                                                 v-model="searchForm.unitCurrency">
                                        </select2>
                                    </div>-->
                                    <label class="col-form-label">Nghìn đồng</label>
                                </b-form-group>
                            </b-col>
                        </b-row>
                        <b-row>
                            <b-col offset-md="1">
                                <b-form-group label="Đơn vị tính diện tích:"
                                              label-for="input-reportyear"
                                              :label-cols="3" label-cols-md="3"
                                              :horizontal="true"
                                              label-align="left">
                                    <!--<div class="col-6 p-l-r-0">
                                        <select2 :options="listUnitArea" name="unitArea"
                                                 v-model="searchForm.unitArea"></select2>
                                    </div>-->
                                    <label class="col-form-label">m²</label>
                                </b-form-group>
                            </b-col>
                        </b-row>
                        <!--<b-row>
                            <b-col offset-md="1">
                                <b-form-group label="Đơn vị tính chiều dài:"
                                              label-for="input-quantity"
                                              :label-cols="3" label-cols-md="3"
                                              :horizontal="true"
                                              label-align="left">
                                    <div class="col-6 p-l-r-0">
                                        <select2 :options="listUnitDistance" name="unitDistance"
                                                 v-model="searchForm.unitDistance">
                                        </select2>
                                    </div>
                                </b-form-group>
                            </b-col>
                        </b-row>
                        <b-row>
                            <b-col offset-md="1">
                                <b-form-group label="Đơn vị tính số lượng:"
                                              label-for="input-quantity"
                                              :label-cols="3" label-cols-md="3"
                                              :horizontal="true"
                                              label-align="left">
                                    <div class="col-6 p-l-r-0">
                                        <select2 :options="listUnitQuantity" name="unitQuantity"
                                                 v-model="searchForm.unitQuantity">
                                        </select2>
                                    </div>
                                </b-form-group>
                            </b-col>
                        </b-row>
                        <b-row v-if="increasementCauseTypeId.length > 0">
                            <b-col offset-md="1">
                                <b-form-group label="Lý do tăng:"
                                              label-for="input-quantity"
                                              :label-cols="3" label-cols-md="3"
                                              :horizontal="true"
                                              label-align="left">
                                    <div class="col-6 p-l-r-0">
                                        <select2 :options="increasementCauses" multiple allowClear placeholder="--- Tất cả ---"
                                                 v-model="searchForm.increasementCauseId">
                                        </select2>
                                    </div>
                                </b-form-group>
                            </b-col>
                        </b-row>
                        <b-row v-if="valueIncreasementCauseTypeId.length > 0">
                            <b-col offset-md="1">
                                <b-form-group label="Lý do tăng nguyên giá:"
                                              label-for="input-quantity"
                                              :label-cols="3" label-cols-md="3"
                                              :horizontal="true"
                                              label-align="left">
                                    <div class="col-6 p-l-r-0">
                                        <select2 :options="valueIncreasementCauses" multiple allowClear placeholder="--- Tất cả ---"
                                                 v-model="searchForm.valueIncreasementCauseId">
                                        </select2>
                                    </div>
                                </b-form-group>
                            </b-col>
                        </b-row>
                        <b-row v-if="decreasementCauseTypeId.length > 0">
                            <b-col offset-md="1">
                                <b-form-group label="Lý do giảm:"
                                              label-for="input-quantity"
                                              :label-cols="3" label-cols-md="3"
                                              :horizontal="true"
                                              label-align="left">
                                    <div class="col-6 p-l-r-0">
                                        <select2 :options="decreasementCauses" multiple allowClear placeholder="--- Tất cả ---"
                                                 v-model="searchForm.decreasementCauseId">
                                        </select2>
                                    </div>
                                </b-form-group>
                            </b-col>
                        </b-row>
                        <b-row v-if="valueDecreasementCauseTypeId.length > 0">
                            <b-col offset-md="1">
                                <b-form-group label="Lý do giảm nguyên giá:"
                                              label-for="input-quantity"
                                              :label-cols="3" label-cols-md="3"
                                              :horizontal="true"
                                              label-align="left">
                                    <div class="col-6 p-l-r-0">
                                        <select2 :options="valueDecreasementCauses" multiple allowClear placeholder="--- Tất cả ---"
                                                 v-model="searchForm.valueDecreasementCauseId">
                                        </select2>
                                    </div>
                                </b-form-group>
                            </b-col>
                        </b-row>
                        <b-row>
                            <b-col offset-md="1">
                                <b-form-group label="Tiêu chí tra cứu khác:"
                                              label-for="input-quantity"
                                              :label-cols="3" label-cols-md="3"
                                              :horizontal="true"
                                              label-align="left">
                                    <div v-for="(criteria, index) in searchForm.otherCriteria" :key="criteria.id">
                                        <div class="p-l-r-0 form-inline mt-1 mb-2">
                                            <div class="mr-sm-2" style="width: 150px">
                                                <select2 :options="availableLookupCriteria"
                                                         v-model="criteria.name">
                                                </select2>
                                            </div>
                                            <template v-if="getCriteria(criteria).options">
                                                <div class="mr-sm-2" style="min-width: 200px">
                                                    <select2 :options="getCriteria(criteria).options" multiple
                                                             allowClear="true" placeholder="--- Tất cả ---"
                                                             v-model="criteria.valueArray" @update:selectedOptions="(options) => criteria.valueArrayString = options.map(x => x.text)">
                                                    </select2>
                                                </div>
                                            </template>
                                            <template v-else>
                                                <div class="mr-sm-2" style="min-width: 120px">
                                                    <select2 :options="operators"
                                                             v-model="criteria.operator">
                                                    </select2>
                                                </div>
                                                <template v-if="criteria.operator == 7">
                                                    <span class="mr-sm-2">Từ:</span>
                                                    <vue-numeric :currency="getCriteria(criteria).symbol" separator="." :precision="getCriteria(criteria).precision" currency-symbol-position="suffix" :min="0" :max="getCriteria(criteria).max" v-model="criteria.valueFrom" class="form-control mr-sm-2" style="width: 150px"></vue-numeric>
                                                    <span class="mr-sm-2">Đến:</span>
                                                    <vue-numeric :currency="getCriteria(criteria).symbol" separator="." :precision="getCriteria(criteria).precision" currency-symbol-position="suffix" :min="0" :max="getCriteria(criteria).max" v-model="criteria.valueTo" class="form-control mr-sm-2" style="width: 150px"></vue-numeric>
                                                </template>
                                                <template v-if="criteria.operator && criteria.operator != 7">
                                                    <vue-numeric :currency="getCriteria(criteria).symbol" separator="." :precision="getCriteria(criteria).precision" currency-symbol-position="suffix" :min="0" :max="getCriteria(criteria).max" v-model="criteria.value" class="form-control mr-sm-2" style="width: 150px"></vue-numeric>
                                                </template>
                                            </template>
                                            <b-button @click="removeCriteria(index)" size="sm" title="Xóa tiêu chí">
                                                <i class="fa fa-remove"></i>
                                            </b-button>
                                        </div>
                                    </div>
                                    <b-button @click="addCriteria()" size="sm" title="Thêm tiêu chí">
                                        <i class="fa fa-plus"></i>
                                    </b-button>
                                </b-form-group>
                            </b-col>
                        </b-row>-->
                        <b-row>
                            <b-col offset-md="1">
                                <b-form-group label="" :label-cols="3" label-cols-md="3">
                                    <b-button type="button" variant="primary" @click="exportReport(false)">Xuất báo cáo</b-button>
                                    <!--<b-button type="button" variant="primary" @click="exportReport(true)">Xuất báo cáo Oracle BI</b-button>
                                    <b-button type="button" variant="secondary" :to="{ path: `/view-reports/lookup/list` }">Thoát</b-button>-->
                                </b-form-group>
                            </b-col>
                        </b-row>
                    </b-form>

                </b-card>
            </b-col>
        </b-row>
    </div>
</template>
<script>
    import { mapState } from 'vuex'
    import { mixins } from '@/shared/mixins'
    import { required, requiredIf, sameAs, minLength, helpers } from 'vuelidate/lib/validators'

    export default {
        name: 'ReportDetail',
        mixins: [mixins],
        data() {
            return {
                reportCode: this.$route.meta.reportCode,
                title: this.$route.meta.title,
                periodType: this.$route.meta.periodType,
                increasementCauseTypeId: this.$route.meta.increasementCauseTypeId ?? [],
                decreasementCauseTypeId: this.$route.meta.decreasementCauseTypeId ?? [],
                valueIncreasementCauseTypeId: this.$route.meta.valueIncreasementCauseTypeId ?? [],
                valueDecreasementCauseTypeId: this.$route.meta.valueDecreasementCauseTypeId ?? [],
                listUnitCurrencys: [{ text: 'Đồng', id: '1' }, { text: 'Nghìn đồng', id: "2" }, { text: 'Triệu đồng', id: '3' }, { text: 'Tỷ đồng', id: '4' }],
                listUnitArea: [{ text: 'm²', id: '1' }, { text: 'Nghìn m²', id: '2' }, { text: 'Mười nghìn m²', id: '3' }],
                listUnitQuantity: [{ text: 'Cái/Khuôn viên', id: '1' }],
                listUnitDistance: [{ text: 'Km', id: '1' }],
                searchForm: {
                    part: 1,
                    reportUserName: this.$store.state.identity.username,
                    syncSourceType: [],
                    dataSource: [],
                    dataPart: [],
                    reportDate: new Date().formatDate(),
                    reportStartDate: new Date(new Date().getFullYear(), 0, 1).formatDate(),
                    reportEndDate: new Date(new Date().getFullYear(), 11, 31).formatDate(),
                    unitId: null,
                    administrativeLevel: '',
                    unitLevelId: null,
                    assetTypeGroupId: [],
                    assetTypeId: [],
                    assetTypeLevel: 1,
                    showAssetDetail: false,
                    unitLevel: 1,
                    unitCurrency: 2,
                    unitArea: 1,
                    unitQuantity: 1,
                    unitDistance: 1,
                    increasementCauseId: [],
                    decreasementCauseId: [],
                    otherCriteria: [],
                    unitTypeSelected: 2,
                    years: [2020]
                },
                lookupCriteria: [
                    { id: 1, name: 'brand', text: 'Nhãn xe', assetTypeGroupIds: [1, 10, 2, 19], options: [] },
                    { id: 2, name: 'dateOfUse', text: 'Năm sử dụng', max: 9999 },
                    { id: 3, name: 'dateOfManufacture', text: 'Năm sản xuất (xây dựng)', max: 9999, assetTypeGroupIds: [1, 8, 9, 10, 11, 12, 13, 14, 15, 16, 2, 18] },
                    { id: 4, name: 'numberOfFloor', text: 'Số tầng', assetTypeGroupIds: [1, 8, 2, 18] },
                    { id: 5, name: 'area', text: 'Diện tích', symbol: 'm²', assetTypeGroupIds: [1, 7, 8, 2, 17, 18] },
                    { id: 6, name: 'vehicleSize', text: 'Số chỗ ngồi', assetTypeGroupIds: [1, 10, 2, 19] },
                    { id: 7, name: 'vehicelCapacity', text: 'Tải trọng', symbol: 'tấn', assetTypeGroupIds: [1, 10, 11, 2, 19] },
                    { id: 8, name: 'originalValueStateBudget', text: 'Nguồn ngân sách', symbol: '₫' },
                    { id: 9, name: 'originalValueODA', text: 'Nguồn ODA', symbol: '₫' },
                    { id: 10, name: 'originalValueAid', text: 'Nguồn vay', symbol: '₫' },
                    { id: 11, name: 'originalValueBorrow', text: 'Nguồn sự nghiệp', symbol: '₫' },
                    { id: 12, name: 'originalValueProgram', text: 'Nguồn chương trình mục tiêu', symbol: '₫', assetTypeGroupIds: [3, 21] },
                    { id: 13, name: 'originalValueOther', text: 'Nguồn khác', symbol: '₫' },
                    { id: 14, name: 'originalValue', text: 'Tổng nguyên giá', symbol: '₫' },
                    { id: 15, name: 'residualValue', text: 'Giá trị còn lại', symbol: '₫' },
                    //{ id: 16, name: 'originalValueDepreciationRate', text: 'Tỷ lệ NG tính khấu hao', symbol: '%', max: 100, precision: 2 },
                ],
                operators: [
                    { id: '', name: 'all', text: '--- Tất cả ---' },
                    { id: 1, name: 'equal', text: '=' },
                    { id: 2, name: 'notEqual', text: '<>' },
                    { id: 3, name: 'greater', text: '>' },
                    { id: 4, name: 'greaterThan', text: '>=' },
                    { id: 5, name: 'less', text: '<' },
                    { id: 6, name: 'lessThan', text: '<=' },
                    { id: 7, name: 'between', text: 'Trong khoảng' },
                ],
                assetTypeGroups: [],
                assetTypes: [],
                countId: 1,
                reportYears: [{ id: 2018, text: '2018' }, { id: 2019, text: '2019' }, { id: 2020, text: '2020' }],
                dataTypes: [
                    { id: 1, text: 'Tài sản tại cơ quan, tổ chức, đơn vị' },
                    { id: 4, text: 'Tài sản công trình nước sạch' },
                    { id: 3, text: 'Tài sản hạ tầng giao thông đường bộ' }
                ],
                dataSources: [
                    { id: 1, text: 'Kho CSDLQGTSC' },
                    { id: 2, text: 'Phần mềm nghiệp vụ' }
                ],
                reportParts: [
                    { id: 1, text: 'Phần 01 - Tổng hợp chung' },
                    { id: 2, text: 'Phần 02 - Chi tiết từng đơn vị trực thuộc' },
                ]
            };
        },
        validations: {
            searchForm: {
                unitId: {
                    required: requiredIf(function () {
                        return !this.isAdmin;
                    })
                },
                reportDate: {
                    required: requiredIf(function () {
                        return this.periodType == 1;
                    })
                },
                reportStartDate: {
                    required: requiredIf(function () {
                        return this.periodType == 2;
                    })
                },
                reportEndDate: {
                    required: requiredIf(function () {
                        return this.periodType == 2;
                    })
                }
            }
        },
        computed: {
            ...mapState({
                listReportAssetTypeLevel: (state) => state.common.listReportAssetTypeLevel,
                listReportUnitLevel: (state) => state.common.listReportUnitLevel,
                topLevelUnits: (state) => state.common.topLevelUnits,
                listSyncDataSources: (state, getters) => getters.getSyncDataSources,
                assetSources: (state, getters) => state.common.assetSources.filter(x => x.parentId == null && x.appliedAssetTypeGroupIds != undefined && x.appliedAssetTypeGroupIds.indexOf(2) != -1).map(x => { return { id: x.id, text: x.name }; }),
                listSyncSourceTypes: (state) => state.common.listSyncSourceTypes,
                increasementCauses: function (state) {
                    return state.common.assetMutationCauses.filter(x => this.increasementCauseTypeId.indexOf(x.causeTypeId) != -1);
                },
                decreasementCauses: function (state) {
                    return state.common.assetMutationCauses.filter(x => this.decreasementCauseTypeId.indexOf(x.causeTypeId) != -1);
                },
                valueIncreasementCauses: function (state) {
                    return state.common.assetMutationCauses.filter(x => this.valueIncreasementCauseTypeId.indexOf(x.causeTypeId) != -1);
                },
                valueDecreasementCauses: function (state) {
                    return state.common.assetMutationCauses.filter(x => this.valueDecreasementCauseTypeId.indexOf(x.causeTypeId) != -1);
                },
                unitLevels: function (state) {
                    switch (parseInt(this.searchForm.administrativeLevel)) {
                        case 1: return state.common.unitLevelsCentral;
                        case 2: return state.common.unitLevelsLocal;
                        default: return state.common.unitLevels;
                    }
                }
            }),
            selectedSyncSourceType() {
                var vm = this;
                return this.listSyncSourceTypes.find(x => x.id == vm.searchForm.syncSourceType);
            },
            selectedGroupIds() {
                if (this.searchForm.assetTypeId != null && this.searchForm.assetTypeId.length > 0) {
                    return this.$store.state.common.assetTypes.filter(x => this.searchForm.assetTypeId.indexOf(x.id) != -1).map(x => x.assetTypeGroupId);
                } else if (this.searchForm.assetTypeGroupId != null && this.searchForm.assetTypeGroupId.length > 0) {
                    return this.searchForm.assetTypeGroupId || [];
                }
            },
            availableLookupCriteria() {
                if (this.selectedGroupIds && this.selectedGroupIds.length > 0) {
                    return this.lookupCriteria.filter(x => x.assetTypeGroupIds == null || this.selectedGroupIds.filter(y => x.assetTypeGroupIds.includes(y)).length > 0);
                } else {
                    return this.lookupCriteria;
                }
            }
        },
        created() {
            var vm = this;
            this.$services.get('lookup/brands').done((data) => {
                vm.lookupCriteria[0].options = data;
                vm.addCriteria();
            });
            this.assetTypeGroups = this.$store.getters.assetTypeGroupTree;
            this.assetTypes = this.$store.getters.assetTypeTreeFull;
        },
        watch: {
        },
        methods: {
            addCriteria() {
                this.searchForm.otherCriteria.push({ id: this.countId++, name: 1, operator: '' });
            },
            removeCriteria(index) {
                this.searchForm.otherCriteria.splice(index, 1);
            },
            getCriteria(criteria) {
                return this.lookupCriteria.find(x => x.id == criteria.name) || {};
            },
            exportReport(oracleBI) {
                this.$v.searchForm.$touch();
                var vm = this;
                if (!vm.$v.searchForm.$invalid) {
                    if (oracleBI) {
                        var reportCode = this.reportCode + `_P${this.searchForm.part}`;
                        var jsonParameter = vm.searchForm;
                        window.open(this.$services.getOracleBIPUrl('BCTC/' + reportCode, reportCode, jsonParameter))
                    } else {
                        var url = `${vm.$services.REPORT_END_POINT}BCTC/${this.reportCode}.aspx`;
                        openWindowWithPost(url, vm.searchForm);
                    }
                }
            }
        }
    }
</script>
<style scoped>
</style>
